import { Button, Col, Form, Row, Card } from "antd";
import React from "react";

import "./GroupedApplications.css";

function GroupedApplications() {
  return (
    <Card title="Grouped Applications" className="grouped-application">
      <Row gutter={[0, 16]}>
        <Col span={24}>
          <Row className="data-row">
            <Col span={6}>
              <span className="onclick-text">Samantha D. Foreman</span>
            </Col>
            <Col span={16}>
              <span>Denied</span>
            </Col>
            <Col span={2}>
              <span className="onclick-text">Ungroup</span>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Form labelCol={{ span: 8 }} colon={false}>
            <Row>
              <Col span={18}>
                <Form.Item label="Application for Group">
                  <a
                    className="onclick-text"
                    href="https://appfol.io/aGqWlnxm"
                    target="_blank"
                  >
                    https://appfol.io/aGqWlnxm
                  </a>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item>
                  <Button>Copy</Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </Card>
  );
}

export default GroupedApplications;
